module.exports = __webpack_public_path__ + "front/img/26.cbb2ace1.png";